import { HttpForm } from "../Support/HttpForm";
import { Product } from "../Product/Product";
import { axios } from "../Support/Axios";
import { Campaign } from "./Campaign";
export class CampaignCodes extends HttpForm {
    account;
    slug;
    campaign;
    product;
    data = {
        sku: null,
        quantity: 1,
        value: null,
    };
    products = false;
    constructor(app, params) {
        super();
        this.campaign = new Campaign(app);
        this.product = new Product();
        this.account = params.account;
        this.slug = params.slug;
    }
    mount() {
        this.loadCampaign()
            .then(() => {
            this.getPrepaidProducts()
                .then(() => this.setLoadingState(true))
                .catch(e => this.setError(e));
        })
            .catch(e => this.setError(e));
    }
    create() {
        let url = '/api/campaign/' + this.slug + '/code';
        return axios.post(url, this.data)
            .then(() => {
            this.navigation.toRouteName('admin.campaign.manage', {
                account: this.account,
                campaign: this.slug,
            });
        })
            .catch(e => this.setError(e));
    }
    hasProducts() {
        return this.products && this.products.length > 0;
    }
    getProducts() {
        if (this.products === false) {
            throw new Error('No Products Loaded');
        }
        return this.products;
    }
    getPrepaidProducts() {
        return this.product.all({
            account: this.account,
            prepaid: true,
            currency: this.campaign.data.currency
        })
            .then((response) => {
            this.products = response.data.data;
        })
            .catch(e => this.setError(e));
    }
    loadCampaign() {
        return this.campaign.getCampaign(this.slug).catch(e => this.setError(e));
    }
}
